const env = process.env.VUE_APP_VOORWIEL_ENV || process.env.NODE_ENV
const config = require(`../config/config.${env}.js`)
module.exports = config
